export default __webpack_public_path__ + "static/media/drink_water.7d8be127.jpg";